import Api from 'libs/api/index';
import axios from 'axios';
import AuthService from 'services/Auth';

/**
 * Candidates API
 *
 * For using in candidates/auto page, pass to constructor {true}
 */
class CandidatesApi extends Api {
  constructor(is_auto = false) {
    super(`cv/candidates${is_auto ? '/auto' : ''}/`);
    this.is_auto = is_auto;
  }

  getExcel(params) {
    const apiUrl = process.env.REACT_APP_API_URL;
    return axios({
      url: `${apiUrl}/cv/candidates${this.is_auto ? '/auto' : ''}.xlsx`,
      method: 'get',
      data: params.data,
      params: params.params,
      responseType: 'blob', // important
      headers: {
        'Content-Type': 'application/json',
        ...(params?.headers || {}),
        'auth-token': AuthService.getToken(),
      },
    });
  }

  // this is for candidates/auto only
  addWishList(id) {
    const apiUrl = process.env.REACT_APP_API_URL;
    return axios({
      url: `${apiUrl}/cv/candidates/${id}/follow`,
      method: 'post',
      data: {},
      params: {},
      headers: {
        'Content-Type': 'application/json',
        'auth-token': AuthService.getToken(),
      },
    });
  }

  autoDestroy(id) {
    const apiUrl = process.env.REACT_APP_API_URL;
    return axios({
      url: `${apiUrl}/cv/candidates/${id}/auto_destroy`,
      method: 'delete',
      data: {},
      params: {},
      headers: {
        'Content-Type': 'application/json',
        'auth-token': AuthService.getToken(),
      },
    });
  }

  getPDFUrl(url) {
    const apiUrl = process.env.REACT_APP_API_URL;
    return axios({
      url: url,
      method: 'get',
      data: {},
      params: {},
      // responseType: 'blob', // important
      headers: {
        'Content-Type': 'application/json',
        'auth-token': AuthService.getToken(),
      },
    });
  }
  getPDF(url) {
    const apiUrl = process.env.REACT_APP_API_URL;
    return axios({
      url: url,
      method: 'get',
      data: {},
      params: {},
      responseType: 'blob', // important
      headers: {
        'Content-Type': 'application/json',
        'auth-token': AuthService.getToken(),
      },
    });
  }
  get = (id, params = {}) => {
    const apiUrl = process.env.REACT_APP_API_URL;
    return axios({
      url: `${apiUrl}/cv/candidates/${id}${this.is_auto ? '/auto_show' : ''}`,
      method: 'get',
      data: {},
      params: {},
      headers: {
        'Content-Type': 'application/json',
        'auth-token': AuthService.getToken(),
      },
    });
  };
}

export default CandidatesApi;
